"use client";
import { createSafeContext } from "../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/Combobox/Combobox.context.ts
const [ComboboxProvider, useComboboxContext] = createSafeContext("Combobox component was not found in tree");
//#endregion
export { ComboboxProvider, useComboboxContext };

//# sourceMappingURL=Combobox.context.mjs.map